<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const store = useStore();
const { t, tm } = useI18n();
const list = computed(() => tm('board.faq.items'));

// 추가: 활성화된 아코디언 인덱스
const activeIndex = ref(null);

function toggleAccordion(idx) {
  activeIndex.value = activeIndex.value === idx ? null : idx;
}
</script>

<template>
  <div class="col-lg-6 pe-5 pb-5">
    <div class="wptb-heading">
      <div class="row">
        <div class="col-md-10">
          <div class="wptb-item--inner">
            <h6 class="wptb-item--subtitle">{{ t('board.faq.subtitle') }}</h6>
            <h2 class="wptb-item--title">
              {{ t('board.faq.title') }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="wptb-accordion wptb-accordion1 wow fadeInUp">
      <div
        class="wptb--item"
        v-for="(item, index) in list.slice(0, 4)"
        :key="index"
        :class="{ active: activeIndex === index }"
      >
        <h6 class="wptb-item-title" @click="toggleAccordion(index)">
          <span>
            <span class="wptb-item--number">Q{{ index + 1 }}</span>
            {{ item?.title?.substring(0, 25) || '' }}
          </span>
          <i class="bi bi-chevron-down"></i>
        </h6>
        <div class="wptb-item--content" v-show="activeIndex === index">{{ item.content || "" }}</div>
      </div>
      <div class="wptb-item--button" v-if="false">
        <button
          class="btn"
          @click="store.dispatch('showHomePopup', { open: true, tab: 'faq' })"
        >
          <span class="btn-readmore--text">
            {{ t('board.faq.viewMore') }} <i class="bi bi-chevron-double-right"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
